<template>
  <div v-if="numproductsLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
  <div v-if="numproductsError" class="mc-error">{{ numproductsError }}</div>
 <router-link v-if="numproductsLoaded" class="cr-banner-link" to="/catalog/">
        <picture class="cr-banner-link__picture">
          <img class="cr-banner-link__image" :src="numproducts.image" width="330" height="140" alt="">
        </picture>
        <div class="cr-banner-link__body">
          <div class="cr-banner-link__title">
            Каталог
          </div>
          <span class="cr-banner-link__footnote">
                            {{ numproducts.num }} {{num_word(numproducts.num, ['товар', 'товара', 'товаров'])}}
                        </span>
        </div>
      </router-link>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import num from "@/mixin/num.vue";
export default {
  data: () => ({

  }),
  mixins: [
    num
  ],
  created() {
    this.fetchNumproducts();
  },
  computed: {
    ...mapGetters('numproducts', [
      'numproducts',
      'numproductsLoading',
      'numproductsError',
      'numproductsLoaded'
    ]),
  },
  components: {},
  methods: {
    ...mapActions('numproducts', [
      'fetchNumproducts'
    ]),
  },
}
</script>